import { format } from 'date-fns';
import { useAppSelector } from 'redux/store/store.types';

import CircularProgress from '@material-ui/core/CircularProgress';

import NibDialog from 'components/common/NibDialog/NibDialog';

type Props = {
  isModalOpen: boolean;
  onClose: () => void;
};

export default function TermsModal({ isModalOpen, onClose }: Props) {
  const { items: terms } = useAppSelector((store) => store.appTerms);

  const lastUpdate =
    (terms.length > 0 && terms.reduce((latest, item) => (item.updated_at > latest ? item.updated_at : latest), '')) ||
    null;

  return (
    <div className="n-container">
      {/* @ts-ignore */}
      <NibDialog
        width={'80%'}
        title=""
        open={isModalOpen}
        // @ts-ignore
        onClose={onClose}
        onlyOk
        disableBackdropClick
      >
        {/* @ts-ignore */}
        <div className="mb-10 md:mb-12.5 container mx-auto p-10">
          <h2 className="text-3xl font-bold mb-5 text-center uppercase">Terms and Conditions</h2>
          <h3 className="text-center">NORX Nordic Exchange AS</h3>
          {lastUpdate && <h4 className="text-sm mb-10 text-center">{format(new Date(lastUpdate), 'LLLL yyyy')}</h4>}
          <div className="w-full flex items-center justify-center min-h-16">
            {terms.length === 0 ? (
              <CircularProgress size={30} color="primary" />
            ) : (
              <div className="flex flex-col gap-6 md:gap-7">
                {terms.map((item) => (
                  <div key={item.id}>
                    <span className="font-bold">{item.title}</span>
                    <div
                      className="[&_:is(h1,h2,h3,h4,h5)]:[all:revert] ml-5"
                      dangerouslySetInnerHTML={{ __html: decodeURIComponent(item.content) }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </NibDialog>
    </div>
  );
}
